import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "src/store";

const selectSelf = (state: RootState) => state;
const selectUser = createSelector(selectSelf, (state) => state.user);

export const selectIsUsererLoading = createSelector(
  selectUser,
  (user) => user.isLoading
);

export const selectUsers = createSelector(
  selectUser,
  (user) => user.users
);

export const selectUserDetail = createSelector(
  selectUser,
  (user) => user.userDetail
);

export const selectRoles = createSelector(
  selectUser,
  (user) => user.roles
);